import MobileDetect from 'mobile-detect'
import _ from 'lodash'
import { getServiceWrapper } from 'core/service-wrapper'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import values from 'core/data-model/constants/values'
import { getUserAgentType, isLoggedIn } from 'identity/selectors'
import { loginRequest } from 'quick-quote/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import { setNotificationMessage } from 'quick-quote/notification/actions'
import { getProceedToOrdinaryProduct } from 'quick-quote/product-common/validate-permission/selectors'
import { getProceedToInvestmentProduct } from 'quick-quote/product-investment/validate-permission/selectors'
import { getIsUserOnline } from 'quick-quote/selectors'

import { getSelectedNeedType } from '../fna/need-and-gap-analysis/selectors'
import { isOnFnaPhase } from '../fna/selectors'

import {
  selectProduct,
  selectProductCategory,
  validateInvestmentProduct,
  validateOrdinaryProduct,
  validateNormalProduct,
} from './actions'
import { BasicPlanSelection } from './components/basic-plan-selection'
import {
  customizeDisplay,
  getDisplayProducts,
  getViewConfiguration,
  getProductCategoryList,
  getProductsInCategory,
  getSelectedDisplayProduct,
  getSelectedDisplayProductCode,
  getSelectedProductCategoryId,
  filterProductsByCategory,
  filterProductCategoryEmpty,
  getAvailableProductCategories,
  getAvailablePlanCode,
} from './selectors'

const mapStateToProps = (state) => {
  const serviceWrapper = getServiceWrapper()
  const userAgentType = getUserAgentType(state)
  const isLb = userAgentType === values.AGENT_TYPE_LB
  const mobileDetect = new MobileDetect(window.navigator.userAgent)
  const isDesktop = !mobileDetect.mobile() && !mobileDetect.tablet()
  const displayProducts = getDisplayProducts(state)
  const productsInCategory = getProductsInCategory(getViewConfiguration(state)) ?? {}
  const categoryList = getProductCategoryList(getViewConfiguration(state)) ?? []
  const productCategories =
    !serviceWrapper.usePartnerApi && getToggles().ENABLE_HIDE_EMPTY_TAB_PRODUCT
      ? filterProductCategoryEmpty(displayProducts, categoryList, productsInCategory, userAgentType)
      : categoryList
  const defaultProductCategoryId = getSelectedProductCategoryId(state)
  const selectedProductCategoryId = productCategories.find((category) => category.id === defaultProductCategoryId)
    ? defaultProductCategoryId
    : _.get(productCategories, '[0].id', '')
  const displayCategory = true
  const productInSelectedCategory = productsInCategory[selectedProductCategoryId] ?? []
  const productList = serviceWrapper.usePartnerApi
    ? _.uniqBy(
        displayProducts.filter((product) => {
          return product.useLegacy
            ? productInSelectedCategory.includes(product.code)
            : productInSelectedCategory.includes(product.packageCode) && product.mainProduct
        }),
        'packageCode'
      ).sort((a, b) => {
        return (
          productInSelectedCategory.indexOf(a.useLegacy ? a.code : a.packageCode) -
          productInSelectedCategory.indexOf(b.useLegacy ? b.code : b.packageCode)
        )
      })
    : filterProductsByCategory(displayProducts, productsInCategory, selectedProductCategoryId, userAgentType)
  const selectedNeedType = getSelectedNeedType(state)
  const availableCategories = getAvailableProductCategories(state)
  const availablePlanCode = getAvailablePlanCode(state)
  const hideHistory = getToggles().ENABLE_FNA_FLOW || (getToggles().DISABLE_HISTORY_FOR_LB && isLb && isDesktop)
  // TODO: [DIGSALTOOL-735] checking if using old config when RPUDR not, remove when RPUDR live.
  // TODO: This is hard coded from old `/core/data/resources/fna-configuration.json` configuration
  const overrideProps = getToggles().ENABLE_FNA_WITH_RPUDR
    ? {}
    : {
        selectedProductCategoryId:
          selectedNeedType === 'SAVING_AND_INVESTMENT' ? 'CATEGORY_LEGACY' : selectedProductCategoryId,
        availableCategories: selectedNeedType === 'SAVING_AND_INVESTMENT' ? ['CATEGORY_LEGACY'] : availableCategories,
        availablePlanCode: selectedNeedType === 'SAVING_AND_INVESTMENT' ? ['SPUL', 'RPUL'] : availablePlanCode,
      }
  const isUserLogin = isLoggedIn(state)
  const isUserOnline = getIsUserOnline(state)

  return {
    displayProducts: serviceWrapper.usePartnerApi ? productList : customizeDisplay(productList),
    selectedProductCode: getSelectedDisplayProductCode(state),
    selectedDisplayPackageCode: _.get(getSelectedDisplayProduct(state), 'packageCode'),
    displayCategory,
    productCategories,
    defaultProductCategoryId,
    selectedProductCategoryId,
    hideHistory,
    allowProceedInvestment: getProceedToInvestmentProduct(state),
    allowProceedOrdinary: getProceedToOrdinaryProduct(state),
    isOnFnaPhase: isOnFnaPhase(state),
    selectedNeedType,
    availableCategories,
    availablePlanCode,
    isUserLogin,
    isUserOnline,
    userAgentType,
    ...overrideProps,
  }
}

const mapDispatchToProps = (dispatch) => ({
  selectProduct: bindActionCreators(selectProduct, dispatch),
  selectProductCategory: bindActionCreators(selectProductCategory, dispatch),
  validateInvestmentProduct: bindActionCreators(validateInvestmentProduct, dispatch),
  validateOrdinaryProduct: bindActionCreators(validateOrdinaryProduct, dispatch),
  validateNormalProduct: bindActionCreators(validateNormalProduct, dispatch),
  needLogin: bindActionCreators(loginRequest, dispatch),
  setNotification: bindActionCreators(setNotificationMessage, dispatch),
})

export const BasicPlanSelectionContainer = connect(mapStateToProps, mapDispatchToProps)(BasicPlanSelection)
